module.exports = __webpack_public_path__ + "img/task-nav-text.453ef16e.png";